const fromCalendarAvailabilityQueryToCalendarAvailability = (data)=>{
    var _perDay;
    const perDay = (_perDay = data === null || data === void 0 ? void 0 : data.availabilityByStoreCodes[0].perDay) !== null && _perDay !== void 0 ? _perDay : {};
    return Object.entries(perDay).reduce((acc, [dateString, { slotsAvailable  }])=>{
        acc[dateString] = slotsAvailable ? slotsAvailable > 0 : false;
        return acc;
    }, {});
};

export { fromCalendarAvailabilityQueryToCalendarAvailability };
//# sourceMappingURL=fromCalendarAvailabilityQueryToCalendarAvailability.js.map
